export const clientUiWorld3dTouchInputConfig = {
  TOUCH_HOLD_MS: 500 as const,
};

export const trackpadConfig = {
  bindingsStorage: "razmak.trackpad-bindings",
  controlsStorage: "razmak.trackpad-controls",
};

export const touchConfig = {
  commandHoldMs: 500,
  movementSlopPx: 8,
  pinchMinDistancePx: 8,
};
